import React from 'react';
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  ariaLabel?: string;
};
export function CTAButton({
  children,
  href,
  onClick,
  variant = 'primary',
  size = 'lg',
  fullWidth = true,
  ariaLabel
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-transform duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-terracotta-300/60';
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base sm:text-lg'
  };
  const variants = {
    primary: 'bg-terracotta-500 text-cream-50 shadow-warm hover:bg-terracotta-600',
    secondary: 'bg-cream-50 text-bark-800 border-2 border-bark-800/15 hover:border-terracotta-500/60 hover:text-terracotta-600'
  };
  const className = [base, sizes[size], variants[variant], fullWidth ? 'w-full' : ''].join(' ');
  if (href) {
    return <a href={href} aria-label={ariaLabel} className={className} onClick={onClick} data-id="element-63" data-mp="19azfc6ps9zfn">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} aria-label={ariaLabel} className={className} data-id="element-64" data-mp="1i91oj9jo7ye0">
      {children}
    </button>;
}